/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './models';
import '../../connect/v2/resources/error';
import './enums';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "channelcontrols": {
        "nested": {
          "configuration": {
            "nested": {
              "UpsertEntityConfigurationRequest": {
                "fields": {
                  "configuration": {
                    "type": ".squareup.channelcontrols.configuration.FulfillmentConfiguration",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "UpsertEntityConfigurationResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "configuration": {
                    "type": ".squareup.channelcontrols.configuration.FulfillmentConfiguration",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ReadEntityConfigurationRequest": {
                "fields": {
                  "entity": {
                    "type": ".squareup.channelcontrols.configuration.EntityIdentifier",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ReadEntityConfigurationResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "configuration": {
                    "type": ".squareup.channelcontrols.configuration.FulfillmentConfiguration",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ReadContextualizedEntityConfigurationRequest": {
                "fields": {
                  "context": {
                    "type": ".squareup.channelcontrols.configuration.EntityIdentifier",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ReadContextualizedEntityConfigurationResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "resolvedConfiguration": {
                    "type": ".squareup.channelcontrols.configuration.FulfillmentConfiguration",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "BulkUpsertEntityConfigurationRequest": {
                "fields": {
                  "configurations": {
                    "type": ".squareup.channelcontrols.configuration.FulfillmentConfiguration",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "BulkUpsertEntityConfigurationResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "results": {
                    "type": ".squareup.channelcontrols.configuration.ConfigurationResult",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "BulkReadEntityConfigurationRequest": {
                "fields": {
                  "entities": {
                    "type": ".squareup.channelcontrols.configuration.EntityIdentifier",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "BulkReadEntityConfigurationResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "results": {
                    "type": ".squareup.channelcontrols.configuration.ConfigurationResult",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "PauseChannelsRequest": {
                "fields": {
                  "merchantId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "idempotencyKey": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "pauseConfigs": {
                    "type": ".squareup.channelcontrols.configuration.PauseTargetConfig",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "source": {
                    "type": ".squareup.channelcontrols.configuration.PauseSource",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "PauseChannelsResponse": {
                "fields": {
                  "processedAt": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "targetResults": {
                    "type": ".squareup.channelcontrols.configuration.TargetOperationResult",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "ResumeChannelsRequest": {
                "fields": {
                  "merchantId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "idempotencyKey": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "resumeConfigs": {
                    "type": ".squareup.channelcontrols.configuration.ResumeTargetConfig",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "source": {
                    "type": ".squareup.channelcontrols.configuration.PauseSource",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "ResumeChannelsResponse": {
                "fields": {
                  "processedAt": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "targetResults": {
                    "type": ".squareup.channelcontrols.configuration.TargetOperationResult",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "GetChannelsPauseStatusRequest": {
                "fields": {
                  "merchantId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "targets": {
                    "type": ".squareup.channelcontrols.configuration.Target",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "GetChannelsPauseStatusResponse": {
                "fields": {
                  "targetStatuses": {
                    "type": ".squareup.channelcontrols.configuration.TargetPauseStatus",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "FulfillmentConfigurationService": {
                "methods": {
                  "UpsertEntityConfiguration": {
                    "requestType": ".squareup.channelcontrols.configuration.UpsertEntityConfigurationRequest",
                    "responseType": ".squareup.channelcontrols.configuration.UpsertEntityConfigurationResponse"
                  },
                  "ReadEntityConfiguration": {
                    "requestType": ".squareup.channelcontrols.configuration.ReadEntityConfigurationRequest",
                    "responseType": ".squareup.channelcontrols.configuration.ReadEntityConfigurationResponse"
                  },
                  "ReadContextualizedEntityConfiguration": {
                    "requestType": ".squareup.channelcontrols.configuration.ReadContextualizedEntityConfigurationRequest",
                    "responseType": ".squareup.channelcontrols.configuration.ReadContextualizedEntityConfigurationResponse"
                  },
                  "PauseChannels": {
                    "requestType": ".squareup.channelcontrols.configuration.PauseChannelsRequest",
                    "responseType": ".squareup.channelcontrols.configuration.PauseChannelsResponse"
                  },
                  "ResumeChannels": {
                    "requestType": ".squareup.channelcontrols.configuration.ResumeChannelsRequest",
                    "responseType": ".squareup.channelcontrols.configuration.ResumeChannelsResponse"
                  },
                  "GetChannelsPauseStatus": {
                    "requestType": ".squareup.channelcontrols.configuration.GetChannelsPauseStatusRequest",
                    "responseType": ".squareup.channelcontrols.configuration.GetChannelsPauseStatusResponse"
                  },
                  "BulkUpsertEntityConfiguration": {
                    "requestType": ".squareup.channelcontrols.configuration.BulkUpsertEntityConfigurationRequest",
                    "responseType": ".squareup.channelcontrols.configuration.BulkUpsertEntityConfigurationResponse"
                  },
                  "BulkReadEntityConfiguration": {
                    "requestType": ".squareup.channelcontrols.configuration.BulkReadEntityConfigurationRequest",
                    "responseType": ".squareup.channelcontrols.configuration.BulkReadEntityConfigurationResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.UpsertEntityConfigurationRequest && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.UpsertEntityConfigurationResponse && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.ReadEntityConfigurationRequest && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.ReadEntityConfigurationResponse && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.ReadContextualizedEntityConfigurationRequest && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.ReadContextualizedEntityConfigurationResponse && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.BulkUpsertEntityConfigurationRequest && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.BulkUpsertEntityConfigurationResponse && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.BulkReadEntityConfigurationRequest && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.BulkReadEntityConfigurationResponse && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.PauseChannelsRequest && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.PauseChannelsResponse && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.ResumeChannelsRequest && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.ResumeChannelsResponse && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.GetChannelsPauseStatusRequest && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.GetChannelsPauseStatusResponse && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.FulfillmentConfigurationService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpsertEntityConfigurationRequest @ squareup/channelcontrols/configuration/service.proto at 15:1
 */
export const UpsertEntityConfigurationRequest = $root.lookupType('squareup.channelcontrols.configuration.UpsertEntityConfigurationRequest');
fixType(UpsertEntityConfigurationRequest);
Builder.createAndAttachToType(UpsertEntityConfigurationRequest);
/**
 * SOURCE UpsertEntityConfigurationResponse @ squareup/channelcontrols/configuration/service.proto at 19:1
 */
export const UpsertEntityConfigurationResponse = $root.lookupType('squareup.channelcontrols.configuration.UpsertEntityConfigurationResponse');
fixType(UpsertEntityConfigurationResponse);
Builder.createAndAttachToType(UpsertEntityConfigurationResponse);
/**
 * SOURCE ReadEntityConfigurationRequest @ squareup/channelcontrols/configuration/service.proto at 25:1
 */
export const ReadEntityConfigurationRequest = $root.lookupType('squareup.channelcontrols.configuration.ReadEntityConfigurationRequest');
fixType(ReadEntityConfigurationRequest);
Builder.createAndAttachToType(ReadEntityConfigurationRequest);
/**
 * SOURCE ReadEntityConfigurationResponse @ squareup/channelcontrols/configuration/service.proto at 29:1
 */
export const ReadEntityConfigurationResponse = $root.lookupType('squareup.channelcontrols.configuration.ReadEntityConfigurationResponse');
fixType(ReadEntityConfigurationResponse);
Builder.createAndAttachToType(ReadEntityConfigurationResponse);
/**
 * SOURCE ReadContextualizedEntityConfigurationRequest @ squareup/channelcontrols/configuration/service.proto at 35:1
 */
export const ReadContextualizedEntityConfigurationRequest = $root.lookupType('squareup.channelcontrols.configuration.ReadContextualizedEntityConfigurationRequest');
fixType(ReadContextualizedEntityConfigurationRequest);
Builder.createAndAttachToType(ReadContextualizedEntityConfigurationRequest);
/**
 * SOURCE ReadContextualizedEntityConfigurationResponse @ squareup/channelcontrols/configuration/service.proto at 39:1
 */
export const ReadContextualizedEntityConfigurationResponse = $root.lookupType('squareup.channelcontrols.configuration.ReadContextualizedEntityConfigurationResponse');
fixType(ReadContextualizedEntityConfigurationResponse);
Builder.createAndAttachToType(ReadContextualizedEntityConfigurationResponse);
/**
 * SOURCE BulkUpsertEntityConfigurationRequest @ squareup/channelcontrols/configuration/service.proto at 45:1
 */
export const BulkUpsertEntityConfigurationRequest = $root.lookupType('squareup.channelcontrols.configuration.BulkUpsertEntityConfigurationRequest');
fixType(BulkUpsertEntityConfigurationRequest);
Builder.createAndAttachToType(BulkUpsertEntityConfigurationRequest);
/**
 * SOURCE BulkUpsertEntityConfigurationResponse @ squareup/channelcontrols/configuration/service.proto at 52:1
 */
export const BulkUpsertEntityConfigurationResponse = $root.lookupType('squareup.channelcontrols.configuration.BulkUpsertEntityConfigurationResponse');
fixType(BulkUpsertEntityConfigurationResponse);
Builder.createAndAttachToType(BulkUpsertEntityConfigurationResponse);
/**
 * SOURCE BulkReadEntityConfigurationRequest @ squareup/channelcontrols/configuration/service.proto at 64:1
 */
export const BulkReadEntityConfigurationRequest = $root.lookupType('squareup.channelcontrols.configuration.BulkReadEntityConfigurationRequest');
fixType(BulkReadEntityConfigurationRequest);
Builder.createAndAttachToType(BulkReadEntityConfigurationRequest);
/**
 * SOURCE BulkReadEntityConfigurationResponse @ squareup/channelcontrols/configuration/service.proto at 71:1
 */
export const BulkReadEntityConfigurationResponse = $root.lookupType('squareup.channelcontrols.configuration.BulkReadEntityConfigurationResponse');
fixType(BulkReadEntityConfigurationResponse);
Builder.createAndAttachToType(BulkReadEntityConfigurationResponse);
/**
 * SOURCE PauseChannelsRequest @ squareup/channelcontrols/configuration/service.proto at 83:1
 */
export const PauseChannelsRequest = $root.lookupType('squareup.channelcontrols.configuration.PauseChannelsRequest');
fixType(PauseChannelsRequest);
Builder.createAndAttachToType(PauseChannelsRequest);
/**
 * SOURCE PauseChannelsResponse @ squareup/channelcontrols/configuration/service.proto at 110:1
 */
export const PauseChannelsResponse = $root.lookupType('squareup.channelcontrols.configuration.PauseChannelsResponse');
fixType(PauseChannelsResponse);
Builder.createAndAttachToType(PauseChannelsResponse);
/**
 * SOURCE ResumeChannelsRequest @ squareup/channelcontrols/configuration/service.proto at 120:1
 */
export const ResumeChannelsRequest = $root.lookupType('squareup.channelcontrols.configuration.ResumeChannelsRequest');
fixType(ResumeChannelsRequest);
Builder.createAndAttachToType(ResumeChannelsRequest);
/**
 * SOURCE ResumeChannelsResponse @ squareup/channelcontrols/configuration/service.proto at 147:1
 */
export const ResumeChannelsResponse = $root.lookupType('squareup.channelcontrols.configuration.ResumeChannelsResponse');
fixType(ResumeChannelsResponse);
Builder.createAndAttachToType(ResumeChannelsResponse);
/**
 * SOURCE GetChannelsPauseStatusRequest @ squareup/channelcontrols/configuration/service.proto at 157:1
 */
export const GetChannelsPauseStatusRequest = $root.lookupType('squareup.channelcontrols.configuration.GetChannelsPauseStatusRequest');
fixType(GetChannelsPauseStatusRequest);
Builder.createAndAttachToType(GetChannelsPauseStatusRequest);
/**
 * SOURCE GetChannelsPauseStatusResponse @ squareup/channelcontrols/configuration/service.proto at 174:1
 */
export const GetChannelsPauseStatusResponse = $root.lookupType('squareup.channelcontrols.configuration.GetChannelsPauseStatusResponse');
fixType(GetChannelsPauseStatusResponse);
Builder.createAndAttachToType(GetChannelsPauseStatusResponse);
/**
 * SOURCE FulfillmentConfigurationService @ squareup/channelcontrols/configuration/service.proto at 179:1
 */
export const FulfillmentConfigurationService = $root.lookupService('squareup.channelcontrols.configuration.FulfillmentConfigurationService');